import { Component, OnInit } from '@angular/core';
import { CrudService } from '../crud.service';
@Component({
  selector: 'app-bba-in-computer-apllications',
  templateUrl: './bba-in-computer-apllications.component.html',
  styleUrls: ['./bba-in-computer-apllications.component.scss']
})
export class BbaInComputerApllicationsComponent implements OnInit {

  constructor(private crudService: CrudService) { }
  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

}
